export default "__VITE_ASSET__BwtWDvDj__"